module.exports = __webpack_public_path__ + "static/img/tabletupianb1.9f1f630.png";